/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { calculateDiscountComboGroupSchema } from "./calculateDiscountComboGroupSchema.ts";
import { discountItemSchema } from "./discountItemSchema.ts";

export const calculateDiscountDetailSchema = z.object({
	id: z.uuid(),
	amount: z.int().min(1),
	groups: z.array(calculateDiscountComboGroupSchema),
	front_item_id: z.uuid().nullish(),
	id_separation_same_combo: z.string(),
	discounts: z.array(discountItemSchema).nullable(),
	total_combo_price: z.string(),
});
